/**
 *	PROJECT			:		CAMWP DEV
 *	DEVELOPER		:		CAMWP DEV Team
 *	DEVELOPER URI	:		https://camwpdev.com
 *	DATE			:		20-August-2016
 */

// $( function() {

var mobileW = 992;

var SWIFL = {
  init: function () {
    // var me = this;
    // this.loadBg();
    // this.slickSlider();
    // this.searchForm();
    // this.mobileMenu();
    // this.sticky();

    // setTimeout(function() {
    //   me.loadBg();
    //   me.slickSlider();
    //   me.searchForm();
    //   me.mobileMenu();
    //   me.sticky();
    // }, 2000);
  },

  // loadBg: function () {
  //   if ($('.has-bg').length) {
  //     $('.has-bg').each(function () {
  //       var bg = $(this).attr('data-bg');

  //       $(this).css({
  //         'background-image': 'url(' + bg + ')',
  //         'background-repeat': 'no-repeat'
  //       });
  //     });
  //   }
  // },

  // initBannerSlider: function () {
  //   var slider = $('.hero-slider');

    // this.loadBg();

  //   if (slider.length) {
  //     slider.slick({
  //       arrows: false,
  //       dots: true,
  //       dotsClass: 'custom-dots container'
  //     });
  //   }
  // },

  // initExpertiseSlider: function () {
    // var slider = $('.our-expertise .slick-slider');

    // if (!slider.length) {
    //   return;
    // }

    // slider.slick({
    //   infinite: false,
    //   rows: 2,
    //   slidesToScroll: 2,
    //   slidesToShow: 2,
    //   dots: true,
    //   arrows: false,
    //   responsive: [
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         rows: 1,
    //         slidesToScroll: 1,
    //         slidesToShow: 1,
    //         arrows: true
    //       }
    //     },
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         rows: 1,
    //         slidesToScroll: 2,
    //         slidesToShow: 2,
    //         arrows: true
    //       }
    //     }
    //   ]
    // });

    // slider.on('afterChange', function (event, slick, currentSlide) {
    //   $('.our-expertise .carousel-ctrl a').removeClass('ctrl-disabled');

    //   if (currentSlide == 0) {
    //     $('.ctrl-prev').addClass('ctrl-disabled');
    //   }

    //   if ((slick.slideCount - currentSlide) <= 1) {
    //     $('.ctrl-next').addClass('ctrl-disabled');
    //   }
    // });

    // $('.ctrl-prev').on('click', function (e) {
    //   e.preventDefault();
    //   $('.our-expertise .slick-slider').slick('slickPrev');
    // });

    // $('.ctrl-next').on('click', function (e) {
    //   e.preventDefault();
    //   $('.our-expertise .slick-slider').slick('slickNext');
    // });
  // },

  // initNetworkSlider: function () {
  //   var slider = $('.our-networks .slick-slider');

  //   if (!slider.length) {
  //     return;
  //   }

  //   slider.slick({
  //     infinite: false,
  //     slidesToScroll: 5,
  //     slidesToShow: 5,
  //     arrows: false,
  //     autoplay: true,
  //     autoplaySpeed: 4000,
  //     responsive: [
  //       {
  //         breakpoint: 576,
  //         settings: {
  //           slidesToScroll: 1,
  //           slidesToShow: 1
  //         }
  //       },
  //       {
  //         breakpoint: 992,
  //         settings: {
  //           slidesToScroll: 3,
  //           slidesToShow: 3,
  //         }
  //       }
  //     ]
  //   });
  // },

  searchForm: function () {

    $('.search-action').on('click', function (e) {

      e.preventDefault();

      if ($(this).hasClass('opened')) {

        $(this).removeClass('opened');

        $(this).find('.fa').removeClass('fa-times').addClass('fa-search');

        $('.search-form').removeClass('bounceIn').addClass('fadeOutUp');

      } else {

        $(this).addClass('opened');

        $(this).find('.fa').removeClass('fa-search').addClass('fa-times');

        $('.search-form').removeClass('fadeOutUp').addClass('bounceIn');

        $('.search-form input[type="text"]').focus();

      }

    });

  },

  mobileMenu: function () {

    // $('#menu').mmenu({

    //   extensions: ["theme-dark"],

    // }, {

    //     clone: true

    //   });

  },

  sticky: function () {
    var headerSticky = $('.page').data('header');

    if (headerSticky.length) {
      $(window).on('load resize scroll', function () {

        console.log('event');

        var winH = $(window).scrollTop();
        var winW = $(window).width();

        if (winW >= mobileW) {

          var headerTopH = $('.window-only .top-header').height() + $('.header-wrapper').height() + 36;

          if (winH > headerTopH) {

            $('#menu').addClass('sticky animated fadeInDown');

            $('.header-wrapper').removeClass('sticky animated fadeInDown');

          } else {

            $('#menu').removeClass('sticky animated fadeInDown');

          }

        } else {

          var headerTopH = $('.mobile-only .top-header').height() + $('.header-wrapper').height();

          if (winH > headerTopH) {

            $('#menu').removeClass('sticky animated fadeInDown');

            $('.header-wrapper').addClass('sticky animated fadeInDown');

          } else {

            $('.header-wrapper').removeClass('sticky animated fadeInDown');

          }

        }

      });

    }

  }

};

module.exports = SWIFL;


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/scripts/script.js
// module id = 273
// module chunks = 4